import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/financial-model/components/FinancialModelInteractive.tsx");
